<template>
  <div class="wave-optics-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="canvas-box">
      <svg width="100%" height="300" viewBox="0 0 400 300">
        <!-- 光源 -->
        <circle cx="20" cy="150" r="10" fill="#ffff00" opacity="0.8">
          <animate attributeName="r" values="8;12;8" dur="1s" repeatCount="indefinite" />
        </circle>
        
        <!-- 屏 -->
        <rect x="350" y="50" width="10" height="200" fill="#111" />
        
        <!-- 条纹强度图 -->
        <g transform="translate(360, 50)">
          <path :d="fringePath" fill="none" :stroke="laserColor" stroke-width="2" />
        </g>

        <!-- 遮光板 -->
        <g v-if="mode === 'interference'">
          <rect x="150" y="50" width="10" height="90" fill="#555" />
          <rect x="150" y="145" width="10" height="10" fill="#555" />
          <rect x="150" y="160" width="10" height="90" fill="#555" />
        </g>
        <g v-else>
          <rect x="150" y="50" width="10" height="95" fill="#555" />
          <rect x="150" y="155" width="10" height="95" fill="#555" />
        </g>

        <!-- 波前图示 (简化) -->
        <path v-for="i in 5" :key="i" :d="`M ${160} ${150} Q ${250} ${150 + i*20} 350 ${150 + i*40}`" fill="none" :stroke="laserColor" opacity="0.2" />
        <path v-for="i in 5" :key="'b'+i" :d="`M ${160} ${150} Q ${250} ${150 - i*20} 350 ${150 - i*40}`" fill="none" :stroke="laserColor" opacity="0.2" />
      </svg>
    </div>

    <div class="settings">
      <div class="row">
        <label>波长 (λ):</label>
        <el-slider v-model="wavelength" :min="400" :max="700" size="mini"></el-slider>
      </div>
      <div class="row">
        <label>缝宽/缝距 (d):</label>
        <el-slider v-model="d" :min="1" :max="10" size="mini"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaveOpticsViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mode: 'interference',
      wavelength: 650, // 默认红光
      d: 5
    }
  },
  computed: {
    laserColor() {
      if (this.wavelength < 450) return '#8b00ff'; // 紫
      if (this.wavelength < 500) return '#0000ff'; // 蓝
      if (this.wavelength < 570) return '#00ff00'; // 绿
      if (this.wavelength < 590) return '#ffff00'; // 黄
      if (this.wavelength < 620) return '#ff7f00'; // 橙
      return '#ff0000'; // 红
    },
    fringePath() {
      // 模拟强度分布 I = cos²(πdy/λL) 或 sin²x/x²
      let dStr = "M 0 0";
      const L = 200; // eslint-disable-line no-unused-vars
      const scale = this.mode === 'interference' ? (this.d / 10) : (1 / this.d);
      
      for (let y = 0; y <= 200; y++) {
        const yCenter = y - 100;
        let intensity = 0;
        if (this.mode === 'interference') {
          intensity = Math.pow(Math.cos(yCenter * scale * (650/this.wavelength) * 0.2), 2);
        } else {
          const x = yCenter * scale * (650/this.wavelength) * 0.1;
          intensity = x === 0 ? 1 : Math.pow(Math.sin(x)/x, 2);
        }
        dStr += ` L ${intensity * 30} ${y}`;
      }
      return dStr;
    }
  }
}
</script>

<style scoped lang="scss">
.wave-optics-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.canvas-box { background: #000; border-radius: 8px; border: 1px solid #333; }
.settings { padding: 15px; background: rgba(255,255,255,0.02); .row { display: flex; align-items: center; gap: 15px; label { width: 100px; font-size: 0.8rem; } .el-slider { flex: 1; } } }
</style>
